import React, { useEffect, useState } from "react";

import { EvtSelect } from "components/select";
import { getItemsFromCollection } from "directus/src/operations";
import { useQuery } from "@tanstack/react-query";

const GradeInput = ({ value, onChange, ...props }) => {
  const [selectedGrade, setSelectedGrade] = useState("");

  useEffect(() => {
    if (value) {
      setSelectedGrade(value);
    }
  }, [value]);

  const { data, isLoading } = useQuery({
    queryKey: [
      "grades",
      {
        fields: ["id", "name"],
      },
    ],
    queryFn: () => {
      return getItemsFromCollection("grades", {
        fields: ["id", "name"],
      });
    },
  });

  function handleChange(value) {
    setSelectedGrade(value);
    onChange?.(value);
  }

  return (
    <EvtSelect
      data={data}
      value={selectedGrade}
      onChange={handleChange}
      labelKey="name"
      valueKey="id"
      isLoading={isLoading}
      {...props}
    />
  );
};

GradeInput.displayName = "GradeInput";

export default GradeInput;
